// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".threshold-entry--container{position:relative;left:60px;width:263px;margin-bottom:8px}.error-threshold--text-block{min-width:56px;text-align:right;background:transparent}.error-threshold-flex--margin{margin:0 4px 8px}.add-error-threshold--button{width:100%;margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
